import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import NowName from '../components/shared/NowName';
import WorkflowStatusBadge from '../components/workflow/WorkflowStatusBadge';
import { formatDateShort } from '../utils/dateFormat';

// Professional qualification declarations — list page
// (docs/modules/workflow-ld-pq.md). Self-service: every logged-in user sees
// their own declarations; holders of ld:pq:review see all of them and act
// from the detail page.
const WorkflowPq = () => {
  const { hasPermission } = useAuth();
  const canReview = hasPermission('ld:pq:review');
  return (
    <WorkflowListShell
      title="Professional Qualification"
      subtitle={canReview
        ? 'Qualification declarations to review.'
        : 'Your qualification declarations.'}
      newTo="/workflow/pq/new"
      newLabel="New Declaration"
      canCreate
      apiPath="/api/ld/pq-requests"
      searchPlaceholder="Search declaration / qualification / staff…"
      rowTo={(r) => `/workflow/pq/${r.id}`}
      columns={[
        {
          key: 'requestNo',
          label: 'Declaration',
          sortKey: 'requestNo',
          className: 'whitespace-nowrap',
          render: (r) => (
            <Link
              to={`/workflow/pq/${r.id}`}
              onClick={(e) => e.stopPropagation()}
              className="text-blue-600 hover:text-blue-800 font-medium"
            >
              {r.requestNo}
            </Link>
          ),
        },
        { key: 'staff', label: 'Staff', sortKey: 'staff', className: 'text-slate-700 whitespace-nowrap', render: (r) => <NowName value={r.staffName} now={r.staffNameNow} /> },
        { key: 'qualification', label: 'Qualification', sortKey: 'qualification', className: 'text-slate-900 max-w-xs truncate', cellTitle: (r) => r.qualificationTitle, render: (r) => r.qualificationTitle },
        { key: 'awardedDate', label: 'Awarded On', sortKey: 'awardedDate', className: 'text-slate-700 whitespace-nowrap', render: (r) => (r.awardedDate ? formatDateShort(r.awardedDate) : '—') },
        // Only the qualifications that need renewing carry one.
        { key: 'expiryDate', label: 'Expires On', sortKey: 'expiryDate', className: 'text-slate-700 whitespace-nowrap', render: (r) => (r.expiryDate ? formatDateShort(r.expiryDate) : '—') },
        { key: 'status', label: 'Status', sortKey: 'status', render: (r) => <WorkflowStatusBadge status={r.status} /> },
        { key: 'createdAt', label: 'Submitted', sortKey: 'createdAt', className: 'text-slate-600 whitespace-nowrap', render: (r) => formatDateShort(r.createdAt) },
      ]}
    />
  );
};

export default WorkflowPq;
